<template>
  <div class="Closures">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.LoadingReport.Seal_Container') }}
    </div>
    <div class="desOfGoods-con">
      <span> {{ $tc('lang.LoadingReport.Seal') }}</span>
      <div class="img">
        <show-img
          :data="closures.lmediaSeal"
          :otherData="{
            mediaName: '铅封',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaSeal',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.LoadingReport.Seal_No') }}</span>
      <div class="img">
        <show-img
          :data="closures.lmediaSealno"
          :otherData="{
            mediaName: '铅封号',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'lmediaSealno',
          }"
          :id="id"
        ></show-img>
      </div>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      id: this.$route.query.id,
    };
  },
  computed: {
    supervisionDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.supervisionDetails),
        );
      },
    },
    closures: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.supervisionImgList.closures),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {},
  methods: {},
};
</script>
<style lang="less">
.Closures {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
    }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table2 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .desOfGoods-table3 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
.reportModal1 {
  .updataForm {
    display: flex;
    .ant-form-item-label {
      text-align: left;
    }
    > div {
      width: 50%;
    }
    .title {
      width: 70%;
      text-align: center;
      margin-top: 5px;
      > button {
        margin-bottom: 3px;
      }
    }
    .part {
      width: 70%;
      padding-top: 10px;
      border-bottom: 1px dashed rgba(25, 21, 37, 0.28);
      display: flex;
      .ant-form-item-label {
        flex-shrink: 0;
      }
      .ant-row {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
